import React from 'react';
import { useParams, useSearchParams } from 'react-router-dom';

import Botao from 'Component/Botao';
import BotaoLink from 'Component/BotaoLink';
import Buscando from 'Component/Buscando';
import Paginacao from 'Component/Paginacao';
import { RelogioDePontoLista } from 'Component/RelogioDePonto';
import SemRegistros from 'Component/SemRegistros';
import { useRecuperarRelogiosDePontoQuery } from 'View/Service/Default/RelogiosDePonto';

const RelogiosDePonto = (): React.ReactElement => {
  const { id = 0 } = useParams();
  const [searchParams, setSearchParams] = useSearchParams();

  const {
    data: { relogios_de_ponto, paginacao } = {},
    isFetching,
    isLoading,
    refetch,
  } = useRecuperarRelogiosDePontoQuery({
    page: searchParams.get('pagina') || 1,
    contain: ['VinculosEmpregaticios.Empresas'],
    options: { usuario_id: id },
  });

  return (
    <React.Fragment>
      <div className="row">
        <div className="col-md-6 mb-3">
          <Botao icone="arrow-clockwise" onClick={refetch} className="me-2" />
          <BotaoLink
            tema="success"
            icone="plus-lg"
            to={`/usuarios/editar/${id}/relogios-de-ponto/adicionar`}
          >
            Adicionar
          </BotaoLink>
        </div>
      </div>
      <Buscando exibir={isLoading} />
      <SemRegistros
        carregando={isLoading}
        registros={relogios_de_ponto?.length}
        redirecionar={`/usuarios/editar/${id}/relogios-de-ponto/adicionar`}
      />
      <div className="bg-white shadow-sm rounded">
        {relogios_de_ponto?.map((relogio) => (
          <RelogioDePontoLista
            key={`${relogio.id}-${relogio.modificado}`}
            dados={relogio}
          />
        ))}
      </div>
      <Paginacao dados={paginacao} desabilitado={isFetching} />
    </React.Fragment>
  );
};

export default RelogiosDePonto;
